// Deploy-time config — read the same way public/index.html does: a
// `config.js` script loaded by index.html at runtime (see client/index.html),
// which sets window.NV_GOOGLE_CLIENT_ID. NOT baked into the Vite bundle, so
// the client id can change without a rebuild.
export function googleClientId(): string {
  return (window as unknown as { NV_GOOGLE_CLIENT_ID?: string }).NV_GOOGLE_CLIENT_ID || '';
}

/**
 * On the live site the API is served from the site's OWN address
 * (app.nvmanager.com/api/*, ledger N-091, 2026-09-24): every call then rides
 * the connection that already loaded the page, instead of opening a new one
 * to api.nvmanager.com — which on some networks hung 40-113 s. Anywhere else
 * (a preview, tests) it stays on api.nvmanager.com.
 */
export const API_BASE = typeof window !== 'undefined' && window.location?.hostname === 'app.nvmanager.com'
  ? ''
  : 'https://api.nvmanager.com';
